'use strict';

module.exports = new Function("return this")();



//////////////////
// WEBPACK FOOTER
// ./node_modules/es5-ext/global.js
// module id = 1325
// module chunks = 1